import {
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import { VenueBusinessSeatsForm, VenueBusinessSeatsTable } from './components';

export const VenueBusinessSeats: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();
  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );

  const userCanEditVenueBusinessSeats = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-business-seats">
        <TouringCardHeader>
          <TouringCardTitle>{t('VENUE_BUSINESS_SEATS.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueBusinessSeats && (
              <EditActionIcon onClick={openModal} />
            )}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueBusinessSeatsTable
            venueBusinessSeats={overviewVersion.businessSeats}
          />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_BUSINESS_SEATS.EDIT_MODAL_TITLE')}
      >
        <VenueBusinessSeatsForm
          venueId={id}
          overviewVersion={version}
          venueBusinessSeats={overviewVersion.businessSeats}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
